module.exports = __webpack_public_path__ + "roboto-latin-700-normal.77ecb942e56f9b036426b98ee1278bc4.hashedasset.woff";